
import store from '../store';
import Constants from '../config/constants';
import {serviceCreateQuiz, serviceGetQuiz, serviceUpdateQuiz,serviceDeleteQuiz} from "../services/Quiz.service";

export const FETCH_INIT = 'FETCH_INIT_QUIZ';
export const FETCHED = 'FETCHED_QUIZ';
export const FETCHED_FAIL = 'FETCHED_FAIL_QUIZ';
export const FETCHED_FILTER = 'FETCHED_FILTER_QUIZ';
export const FETCH_NEXT = 'FETCH_NEXT_QUIZ';
export const FILTER = 'FILTER_QUIZ';
export const RESET_FILTER = 'RESET_FILTER_QUIZ';
export const SET_SORTING = 'SET_SORTING_QUIZ';
export const SET_FILTER = 'SET_FILTER_QUIZ';
export const SET_PAGE = 'SET_PAGE_QUIZ';
export const CHANGE_PAGE = 'CHANGE_PAGE_QUIZ';
export const CHANGE_STATUS= 'CHANGE_STATE_QUIZ';
export const SET_SERVER_PAGE = 'SET_SERVER_PAGE_QUIZ';
export const CREATE_DATA = 'CREATE_QUIZ';
export const UPDATE_DATA = 'UPDATE_QUIZ';
export const DELETE_ITEM = 'DELETE_QUIZ';
export const DRAG_ITEM = 'DRAG_QUIZ';

export function actionFetchQuiz(index = 1, sorting = {}, filter = {}, shouldReset=false) {
    const request = serviceGetQuiz({ index, row: sorting.row, order: sorting.order, ...filter });
    return (dispatch) => {
        if (shouldReset) {
            dispatch({
                type: CHANGE_PAGE,
                payload: 1,
            });
        }
        dispatch({type: FETCH_INIT, payload: null});
        request.then((data) => {
            dispatch({type: SET_FILTER, payload: filter});
            dispatch({type: SET_SORTING, payload: sorting});
            if (!data.error) {
                dispatch({type: FETCHED, payload: { data: data.data, page: index }});
                dispatch({ type: SET_SERVER_PAGE, payload: index });
                if (index == 1) {
                    dispatch({type: CHANGE_PAGE, payload: index - 1});
                }
            } else {
                dispatch({type: FETCHED_FAIL, payload: null});
            }
        });
    };
}

export function actionCreateQuiz(data) {
    const request = serviceCreateQuiz(data);
    return (dispatch) => {
        request.then((data) => {
            if (!data.error) {
                dispatch({type: CREATE_DATA, payload: data.data})
            }
        })
    }
}

export function actionUpdateQuiz(data) {
    const request = serviceUpdateQuiz(data);
    return (dispatch) => {
        request.then((data) => {
            if (!data.error) {
                dispatch({type: UPDATE_DATA, payload: data.data})
            }
        })
    }
}

export function actionDeleteQuiz(id) {
    const request = serviceDeleteQuiz({ id: id});
    return (dispatch) => {
        dispatch({type: DELETE_ITEM, payload: id})
    }
}


export function actionChangePageQuizRequests(page) {
    return (dispatch) => {
        dispatch({type: CHANGE_PAGE, payload: page})
    }
}

export function actionFilterQuiz(value) {
    const request = null;////serviceFetchProviderRequests(value);
    return (dispatch) => {
        dispatch({type: FETCH_INIT, payload: null});
        request.then((data) => {
            dispatch({type: FILTER, payload: data});
            dispatch({type: FETCHED, payload: null});//dispatch function
        });
    };
}


export function actionChangeStatusQuiz(id, status) {
    // const request = serviceFetchProviderRequests(value);
    return (dispatch) => {
        dispatch({type: CHANGE_STATUS, payload: {id, status}});
    };
}

export function actionResetFilterQuiz() {
    return {
        type: RESET_FILTER,
        payload: null,
    };
}

export function actionDragQuiz(dragId, dragOverId) {
    return {
        type: DRAG_ITEM,
        payload: {dragId, dragOverId}
    }
}

export function actionSetPageQuiz(page) {
    const stateData = store.getState().quiz;
    const currentPage = stateData.currentPage;
    const totalLength = stateData.all.length;
    const sortingData = stateData.sorting_data;
    const query = stateData.query;
    const queryData = stateData.query_data;
    const serverPage = stateData.serverPage;

    if (totalLength <= ((page + 1) * Constants.DEFAULT_PAGE_VALUE)) {
        store.dispatch(actionFetchQuiz(serverPage + 1, sortingData, {query, query_data: queryData}));
    }


    return {
        type: CHANGE_PAGE,
        payload: page,
    };

}
